<template>
  <div class="page-header-index-wide">

    <a-row :gutter="24">
      <a-col justify="center" :sm="12" :md="12" :xl="12" :style="{ marginBottom: '24px'}">
        <a-card style="height: 500px" :title="language['home.todo']">
          <a-table size="middle"
                   bordered
                   :columns="columns"
                   :data-source="this.sourceBacklog">
            <span slot="details" slot-scope="text, record">
              <a @click="showCheckTableInfo(record)">{{language['show.detail']}}</a>
            </span>
          </a-table>

        </a-card>

      </a-col>
      <a-col justify="center" :sm="12" :md="12" :xl="12" :style="{ marginBottom: '24px'}">
        <a-card style="height: 500px;" :title="stateTitle" :body-style="{'text-align':'center'}">
          <a slot="extra" @click="showStateTableInfo">{{language['show.detail']}}</a>
            <bar :dataSource="this.sourceDataState"/>
        </a-card>
      </a-col>
    </a-row>

    <a-row :gutter="24">
      <a-col justify="center" :sm="12" :md="12" :xl="12" :style="{ marginBottom: '24px' }">
        <a-card style="height: 500px" :title="levelTitle">
          <a slot="extra" @click="showLevelTableInfo">{{language['show.detail']}}</a>
          <bar :dataSource="this.sourceDataLevel"/>
        </a-card>
      </a-col>
      <a-col justify="center" :sm="12" :md="12" :xl="12" :style="{ marginBottom: '24px', }">
        <a-card style="height: 500px" :title="typeTitle">
          <a slot="extra" @click="showTypeTableInfo">{{language['show.detail']}}</a>
            <v-chart :forceFit="true" :extend="chartExtend" :height="height" :data="data">
              <v-tooltip />
              <v-axis />
              <v-legend />
              <v-stack-bar position="事業處*隱患數量"  color="name" />
            </v-chart>

         <!-- <div id="container" style="min-width:400px;height:400px"></div>-->
        </a-card>
      </a-col>
    </a-row>

  </div>
</template>

<script>
  import Bar from '@/components/chart/Bar'
  import { getAction, postAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
/*  import Highcharts from 'highcharts';*/

  export default {
    name: 'JCHomeIndex',
    //mixins:[JeecgListMixin],
    components: {
      Bar
    },
    data() {
      this.chartExtend = {
        /* series:{
              barMaxWidth:20
            },
        dataZoom:[{
              type:"inside"
            }],
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: -60,
          },
        }, */
      };

      return {
        yaxisText: '123213',
        url: {
          danger_list: '/epm/epDanger/checkList',
          list: '/epm/report/getDangerLevelReport',
          report_state_list: '/epm/report/getDangerStateReport',
          listUnit: "/epm/report/queryDangerUnitList",
          report_type_list: '/epm/report/getDangerTypeReport',
          todo_list: "/sys/wfapi/getAllToDoTaskList",
        },

        parm: {
         pageNo: 1,
          pageSize: 10,
          inspectFlag: 1,
          startTime:null,
          endTime:null,
          order: "desc",
          appCode:'env_audit'
        },
        queryParam: {
          workNo:this.$store.getters.userInfo.workNo,
        },
        sourceBacklog: [],
        sourceDataState: [],
        sourceDataLevel: [],
        sourceDataType: [],
        height: 400,

        curData: '',
        stateTitle: '',
        levelTitle: '',
        typeTitle: '',

        total:{
          MF:0,
          TW:0,
          TA:0,
          TN:0,
          TS:0,
          TR:0,
          TH:0,
          DW:0,
          DA:0,
          EO:0,
          EM:0,
          sumTotal:0
        },
        dataList:[],
        dataSource:[],
        data:[],
        fields_list:[],
      }
    },
    created() {
      this.initQueryDate();
      this.getTodoList();
      this.getDangerType()
      this.getDangerList()
      this.getDangerLevel()
      this.getDangerState()

      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate();

      console.log(yy + '/' + mm + "/" + dd)

      this.curData = yy + '/' + mm
      this.stateTitle = this.language['danger.state.table'] + '(' + this.curData + ')'
      this.levelTitle = this.language['danger.level.table'] + '(' + this.curData + ')'
      this.typeTitle = this.language['danger.type.table'] + '(' + this.curData + ')'
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns() {
        if (this.language) {
          return [
            {
              title: this.language['common.serialNumber'],
              dataIndex: '',
              key: 'rowIndex',
              width: 60,
              align: 'center',
              customRender: function(t, r, index) {
                return parseInt(index) + 1
              }
            },
            {
              title: this.language['todo.type'],
              align: 'center',
              sorter: true,
              dataIndex: 'name'
            },
            {
              title: this.language['number'],
              align: 'center',
              sorter: true,
              dataIndex: 'count'
            },
            {
              title: this.language['common.detailsButton'],
              align: 'center',
              sorter: true,
              //   dataIndex: 'dangerNo',
              scopedSlots: { customRender: 'details' }
            }
          ]
        }
      }
    },
    methods: {

      //查看详情-隐患复查
      showCheckTableInfo(record) {

        if (this.language['todo.sign'] == record.name) {
          this.$router.push({ path: "/eletronicSigned/MyTodoList" });
          console.log(record.name)
        }
        if (this.language['todo.review'] == record.name) {
          this.$router.push({ path: "/epdanger/epDangerCheckList" });
          console.log(record.name)
        }
      },
      //查看详情-隐患状态分析
      showStateTableInfo() {
        this.$router.push({ path: "/epreport/EpDangerStateReport" });
      },
      //查看详情-隐患程度分析
      showLevelTableInfo() {
        this.$router.push({ path: "/epreport/EpDangerLevelReport" });
      },
      //查看详情-隐患类型分析
      showTypeTableInfo() {
        this.$router.push({ path: "/epreport/EpDangerTypeReport" });
      },

      initQueryDate(){
        this.parm.startTime = this.getOneMonthDate()
        this.parm.endTime = this.getNowDate()
      },
      getNowDate()
      {
        let month =parseInt(new Date().getMonth())+1;
        return new Date().getFullYear()+"/"+month+"/"+new Date().getDate();
      },
      getOneMonthDate()
      {
        const dates = new Date()
        dates.setMonth(dates.getMonth() - 1)
        let pastMonth = dates.getMonth() + 1
        let pastDay = dates.getDate()
        if (pastMonth >= 1 && pastMonth <= 9) {
          pastMonth = '0' + pastMonth
        }
        if (pastDay >= 0 && pastDay <= 9) {
          pastDay = '0' + pastDay
        }
        const endDate = dates.getFullYear() + '-' + pastMonth + '-' + pastDay
        return endDate
        //return new Date().getFullYear()+"/"+new Date().getMonth()+"/"+new Date().getDate();
      },

      getTodoList() {
        getAction(this.url.todo_list, this.queryParam).then((res) => {
          if (res.success) {
            let records = res.result.records || res.result
            console.log('records-->',records)
            if (records == 0) {
              let item = { 'name': this.language['todo.sign'], 'count': 0 }
              this.sourceBacklog.push(item)
            } else {
              let len = records.length || records
              let item = { 'name': this.language['todo.sign'], 'count': len }
              this.sourceBacklog.push(item)
            }

          }
        })
      },

      getDangerList() {
        getAction(this.url.danger_list, { pageNo: 1, pageSize: 1000,inspectFlag:1,appCode:'env_audit' }).then((res) => {
          let records = res.result.records
          let len = records.length

          let item = { 'name': this.language['todo.review'], 'count': len }
          this.sourceBacklog.push(item)

        })
      },

      //隐患程度报表数据
      getDangerLevel() {
        postAction(this.url.list, this.parm).then((res) => {
          let records = res.result.records || res.result
          records = records.slice(0,5)
          if (records.length > 1) {
            for (var index in records) {

              let obj = records[index]

              if (obj.businessUnitName != '合计') {
                //let name_ = obj.businessUnitName;
            //    let name_ = obj.factoryName+','+obj.personName+','+obj.businessGroupName+','+obj.businessUnitName;
                let name_ = '\n\n\n\n' + obj.factoryName+',\n'+obj.personName+',\n'+obj.businessGroupName+',\n'+obj.businessUnitName;
                let item1 = { name: name_, type: this.language['levelNum1'], value: obj.levelNum1 }
                let item2 = { name: name_, type: this.language['levelNum2'], value: obj.levelNum2 }
                let item3 = { name: name_, type: this.language['levelNum3'], value: obj.levelNum3 }
                let item4 = { name: name_, type: this.language['levelNum4'], value: obj.levelNum4 }

                this.sourceDataLevel.push(item1)
                this.sourceDataLevel.push(item2)
                this.sourceDataLevel.push(item3)
                this.sourceDataLevel.push(item4)
              }
            }
          } else {
            this.defaultLevelData()
          }
        })
      },

      defaultLevelData() {
        this.sourceDataLevel.push({name: '', type:this.language['levelNum1'], value: 0})
        this.sourceDataLevel.push({name:'', type: this.language['levelNum2'], value: 0})
        this.sourceDataLevel.push({name: '', type:this.language['levelNum3'], value: 0})
        this.sourceDataLevel.push({name: '', type:this.language['levelNum4'], value: 0})
      },

      getDangerType() {
        postAction(this.url.listUnit, this.parm).then((res) => {
          if (res.success) {
            const result = res.result.records || res.result
            this.dataSource = result.map((v, i)=>{
              v.key = i + 1;
              return v;
            }) || res.result;

            postAction(this.url.report_type_list, this.parm).then((res2) => {
              if (res2.success) {
                const result = res2.result.records || res2.result
                this.dataList = result.map((v, i)=>{
                  v.key = i + 1;
                  return v;
                }) || res.result;

                console.log("datalist ******** 1111" , this.dataList);
                this.total.MF = this.dataList.filter(function(item){ return item.dangerType == "MF"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TW = this.dataList.filter(function(item){ return item.dangerType == "TW"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TA = this.dataList.filter(function(item){ return item.dangerType == "TA"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TN = this.dataList.filter(function(item){ return item.dangerType == "TN"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TS = this.dataList.filter(function(item){ return item.dangerType == "TS"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TR = this.dataList.filter(function(item){ return item.dangerType == "TR"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TH = this.dataList.filter(function(item){ return item.dangerType == "TH"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.DW = this.dataList.filter(function(item){ return item.dangerType == "DW"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.DA = this.dataList.filter(function(item){ return item.dangerType == "DA"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.EO = this.dataList.filter(function(item){ return item.dangerType == "EO"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.EM = this.dataList.filter(function(item){ return item.dangerType == "EM"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.sumTotal = parseInt(this.total.MF) + parseInt(this.total.TW)+parseInt(this.total.TA)+parseInt(this.total.TN)+parseInt(this.total.TS) +parseInt(this.total.TR) + parseInt(this.total.TH) +parseInt(this.total.DW)+parseInt(this.total.DA)+parseInt(this.total.EO)+ parseInt(this.total.EM);
                console.log('----total---' + this.total.sumTotal);
                let attr=['MF','TW','TA','TN','TS','TR','TH','DW','DA','EO','EM'];
                attr.forEach((k)=>{
                  let levelitem = {name:k};
                  if (this.dataList == 0) {
                    levelitem[""] = 0;
                    this.sourceDataType.push(levelitem);
                  } else {

                    console.log('333333333 dataList --------->' , this.dataList)

                    this.dataList.map((item,index,arr)=>{
                      if(item.dangerType == k)
                      {
                        let person = item.legalpersonName==null?"":item.legalpersonName;
                        //let name = item.factoryName +","+person+","+item.businessGroupName+","+item.businessUnitName;
                        //let name = item.businessGroupName+"/"+item.businessUnitName;
                        let name = '\n\n\n\n' + item.factoryName +",\n"+person+",\n"+item.businessGroupName+",\n"+item.businessUnitName;

                        let num = item.dangerTypeNum;
                        if(num != "0")
                        {
                          levelitem[name] = num;
                        }
                      }
                    });
                    this.sourceDataType.push(levelitem);
                  }
                });

                console.log('11111111 sourceDataType --->' , this.sourceDataType)

                if (this.dataSource.length ==0) {
                  this.fields_list.push('');   //没有数据，默认
                } else {
                //  this.fields_list = this.dataSource.map((item, index)=>`${item.factoryName}/${item.legalpersonCode}/${item.businessGroupName}/${item.businessUnitName}`)

                 this.dataSource = this.dataSource.slice(0,5)
                  this.dataSource.forEach((item, index)=>{
                    let person = item.legalpersonName==null?"":item.legalpersonName;
                    let name = '\n\n\n\n' + item.factoryName +",\n"+person+",\n"+item.businessGroupName+",\n"+item.businessUnitName;
                    //let name = item.factoryName +","+person+","+item.businessGroupName+","+item.businessUnitName;
                    //let name = item.businessGroupName+"/"+item.businessUnitName;
                    this.fields_list.push(name);
                  });
                }

               /* this.fields_list = this.fields_list.slice(0,4)
                this.sourceDataType =  this.sourceDataType.slice(0,4)
*/
                console.log('33333 fields_list --->' , this.fields_list)
                console.log('444444',this.sourceDataType)
                const DataSet = require('@antv/data-set');
                const dv = new DataSet.View().source(this.sourceDataType);
                dv.transform({
                  type: 'fold',
                  fields: this.fields_list,
                  key: '事業處',
                  value: '隱患數量',
              //    retains: ['name']
                });

                this.data = dv.rows;
              }else{
                this.$message.warning(res.message)
              }
            }).finally(() => {
               this.loading = false;
               this.fields_list =[];
               this.sourceDataType=[];
            });
          }else{
            this.$message.warning(res.message)
          }
        })
      },

      //隐患状态报表数据
      getDangerState() {

        postAction(this.url.report_state_list, this.parm).then((res) => {
          let records = res.result.records || res.result
          records = records.slice(0,5)
          console.log('11111 records---->',records)
          if (records.length > 1) {
            for (var index in records) {
              let obj = records[index]
              if (obj.businessUnitName != '合计') {
            //    let name_ = obj.businessUnitName;
                let name_ = '\n\n\n\n' + obj.factoryName+',\n'+obj.personName+',\n'+obj.businessGroupName+',\n'+obj.businessUnitName;
                this.sourceDataState.push({ name: name_, type: this.language['common.save'], value: obj.saveState })
                this.sourceDataState.push({ name: name_, type: this.language['signingState'], value: obj.signingState })
                this.sourceDataState.push({ name: name_, type: this.language['signedState'], value: obj.signedState })
                this.sourceDataState.push({ name: name_, type: this.language['deferSignState'], value: obj.deferSignState })
                this.sourceDataState.push({ name: name_, type: this.language['deferConfirmState'], value: obj.deferConfirmState })
                this.sourceDataState.push({ name: name_, type: this.language['rectifyedState'], value: obj.rectifyedState })
                this.sourceDataState.push({ name: name_, type: this.language['archivePassState'], value: obj.archivePassState })
                this.sourceDataState.push({ name: name_, type: this.language['archiveCancelState'], value: obj.archiveCancelState })
              }
            }
          } else {
            this.defaultStateData()
          }
        })
      },

      defaultStateData() {
        this.sourceDataState.push({ name: '', type: this.language['common.save'], value: 0 })
        this.sourceDataState.push({ name: '', type: this.language['signingState'], value: 0 })
        this.sourceDataState.push({ name: '', type: this.language['signedState'], value:0})
        this.sourceDataState.push({ name: '', type: this.language['deferSignState'], value:0 })
        this.sourceDataState.push({ name: '', type: this.language['deferConfirmState'], value: 0 })
        this.sourceDataState.push({ name: '', type: this.language['rectifyedState'], value: 0 })
        this.sourceDataState.push({ name: '', type: this.language['archivePassState'], value: 0 })
        this.sourceDataState.push({ name: '', type: this.language['archiveCancelState'], value:0 })
      }


    }
  }
</script>

<style lang="less" scoped>

</style>